module.exports = __webpack_public_path__ + "img/9788954438049.2b6571a3.jpg";